module.exports = __webpack_public_path__ + "static/mariki-139128cdb383172cd4d74ce06676c1d1.png";